
import { BusinessUnitAddressEntityDecoratorBase } from './business-unit-address.decorator.base';


export class BusinessUnitAddressEntityDecorator extends BusinessUnitAddressEntityDecoratorBase {
  constructor() {
    super();
  }
}



